import React from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system';
import Modal from 'utils/packages/Modal';
import { IconFatPlus } from 'design-system/icons';
import { SettingsItem } from 'design-system/SettingsItem';
import IconThreeUser from 'design-system/icons/IconThreeUser';
const AddGroupModalContent = ({ onJoinGroup, onCreateGroup, }) => (<View style={styles.modalContent}>
    <SettingsItem icon={<IconFatPlus />} title="Create a group" onPress={() => Modal.hide(onCreateGroup)}/>
    <SettingsItem icon={<IconThreeUser gradientKey="orange"/>} title="Join a group" onPress={() => Modal.hide(onJoinGroup)}/>
  </View>);
export default AddGroupModalContent;
const styles = StyleSheet.create({
    modalContent: {
        paddingTop: rem(8),
    },
});
